// BARCINO — Header global : scroll + mega-menu + hamburger + promo-bar
// Présent sur toutes les pages (header hors conteneur Barba) — initialisé une
// seule fois au chargement, indépendamment du cycle de vie Barba.
const barcinoHeader = {

    init() {
        const header    = document.getElementById('site-header');
        const megaItem  = document.querySelector('.site-header__nav-item--has-mega');
        const megaMenu  = document.getElementById('mega-menu');
        const megaClose = document.querySelector('[data-mega-close]');
        const burger    = document.querySelector('[data-nav-toggle]');
        const mobileNav = document.getElementById('mobile-nav');
        const navClose  = document.querySelector('[data-nav-close]');
        const subToggle = document.querySelector('[data-sub-toggle]');
        const subBack   = document.querySelector('[data-sub-back]');
        const promoClose = document.querySelector('[data-promo-close]');
        const promoBanner = document.getElementById('promo-banner');

        // Durée de la transition de fermeture de .mobile-nav (voir _barcino_nav.scss)
        const MOBILE_NAV_CLOSE_MS = 600;

        // Si on ferme depuis le sous-panneau (ex: "Nos Cafés"), le panneau
        // remonte tel quel (avec ses catégories) — on ne réinitialise vers la
        // liste principale qu'une fois totalement remonté, pour ne jamais
        // voir la liste principale repasser avant la fermeture
        const resetSubPanelAfterClose = () => {
            setTimeout(() => {
                mobileNav.classList.remove('is-sub-open');
            }, MOBILE_NAV_CLOSE_MS);
        };

        const closeMobileNav = () => {
            if (!mobileNav || !burger) return;
            mobileNav.classList.remove('is-open');
            burger.classList.remove('is-open');
            header?.classList.remove('is-mobile-nav-open');
            document.body.classList.remove('mobile-nav-open');
            mobileNav.setAttribute('aria-hidden', 'true');
            mobileNav.inert = true;
            burger.setAttribute('aria-label', 'Ouvrir le menu');
            const subPanel = mobileNav.querySelector('.mobile-nav__panel--sub');
            if (subPanel) { subPanel.setAttribute('aria-hidden', 'true'); subPanel.inert = true; }
            resetSubPanelAfterClose();
        };

        // Fond blanc au scroll — aussi sur .is-nav-dark : la ligne pleine
        // largeur ne s'affiche qu'au repos (voir _barcino_nav.scss), remplacée
        // par le même bloc blanc flottant que le header par défaut dès que
        // .is-scrolled est actif (donc aussi quand il redescend au scroll up).
        if (header) {
            const onScroll = () => {
                header.classList.toggle('is-scrolled', window.scrollY > 200);
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        // Hauteur réelle du header (varie selon bandeau promo affiché/fermé et
        // breakpoint) exposée en variable CSS — utilisée par ._page-header-offset
        // pour décaler le contenu des pages .is-nav-dark, désormais fixe lui aussi.
        if (header) {
            const syncPromoHeight = () => {
                const promoHeight = promoBanner && !promoBanner.classList.contains('is-hidden')
                    ? promoBanner.offsetHeight
                    : 0;
                header.classList.toggle('has-promo-banner', promoHeight > 0);
                document.documentElement.style.setProperty('--bc-promo-h', `${promoHeight}px`);
            };
            const syncHeaderHeight = () => {
                syncPromoHeight();
                document.documentElement.style.setProperty('--bc-header-h', header.offsetHeight + 'px');
            };
            syncHeaderHeight();
            window.addEventListener('resize', syncHeaderHeight, { passive: true });
            if (promoBanner) {
                promoBanner.addEventListener('transitionend', (event) => {
                    if (event.propertyName === 'max-height') syncHeaderHeight();
                });
            }
        }

        // Mega-menu au survol de "Nos Cafés"
        if (megaItem && megaMenu && header) {
            let closeTimer = null;

            const openMega = () => {
                clearTimeout(closeTimer);
                megaMenu.classList.add('is-open');
                megaMenu.setAttribute('aria-hidden', 'false');
                megaMenu.inert = false;
                header.classList.add('mega-open');
            };
            const closeMega = () => {
                megaMenu.classList.remove('is-open');
                megaMenu.setAttribute('aria-hidden', 'true');
                megaMenu.inert = true;
                header.classList.remove('mega-open');
            };
            const scheduledClose = () => {
                closeTimer = setTimeout(closeMega, 80);
            };

            megaItem.addEventListener('mouseenter', openMega);
            megaMenu.addEventListener('mouseenter', openMega);
            megaItem.addEventListener('mouseleave', (e) => {
                if (!megaMenu.contains(e.relatedTarget)) scheduledClose();
            });
            megaMenu.addEventListener('mouseleave', (e) => {
                if (!megaItem.contains(e.relatedTarget)) scheduledClose();
            });
            if (megaClose) megaClose.addEventListener('click', closeMega);

            // "Nos Cafés" est un <button> sans href (voir nav.php) : il ne sert
            // qu'à ouvrir/fermer le mega-menu, jamais à naviguer.
            // Le clic-bascule ne doit agir qu'au tactile ou au clavier : à la
            // souris, mouseenter ouvre déjà le menu avant que le clic n'arrive,
            // donc un clic-bascule non filtré le refermerait aussitôt.
            // On se base sur pointerType de l'évènement réel (fiable) plutôt
            // que sur matchMedia('hover'), qui peut se tromper avec
            // l'émulation tactile de DevTools (hover fantôme après le tap).
            const megaTrigger = megaItem.querySelector('[data-mega-trigger]');
            if (megaTrigger) {
                megaTrigger.addEventListener('pointerup', (event) => {
                    if (event.pointerType !== 'touch') return;
                    if (megaMenu.classList.contains('is-open')) {
                        closeMega();
                    } else {
                        openMega();
                    }
                });
                // event.detail === 0 : activation clavier (Enter/Espace), pas souris/tactile
                megaTrigger.addEventListener('click', (event) => {
                    if (event.detail !== 0) return;
                    if (megaMenu.classList.contains('is-open')) {
                        closeMega();
                    } else {
                        openMega();
                    }
                });
            }
        }

        // Hamburger → ouvre le menu mobile
        if (burger && mobileNav) {
            burger.addEventListener('click', () => {
                const open = mobileNav.classList.toggle('is-open');
                burger.classList.toggle('is-open', open);
                header?.classList.toggle('is-mobile-nav-open', open);
                document.body.classList.toggle('mobile-nav-open', open);
                mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
                mobileNav.inert = !open;
                burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
                if (!open) {
                    const subPanel = mobileNav.querySelector('.mobile-nav__panel--sub');
                    if (subPanel) { subPanel.setAttribute('aria-hidden', 'true'); subPanel.inert = true; }
                    resetSubPanelAfterClose();
                }
            });
        }

        // Bouton fermer du menu mobile
        if (navClose && mobileNav && burger) {
            navClose.addEventListener('click', closeMobileNav);
        }

        // Sous-menu mobile "Nos cafés"
        if (subToggle && mobileNav) {
            subToggle.addEventListener('click', () => {
                mobileNav.classList.add('is-sub-open');
                const subPanel = mobileNav.querySelector('.mobile-nav__panel--sub');
                if (subPanel) { subPanel.setAttribute('aria-hidden', 'false'); subPanel.inert = false; }
            });
        }

        if (subBack && mobileNav) {
            subBack.addEventListener('click', () => {
                mobileNav.classList.remove('is-sub-open');
                const subPanel = mobileNav.querySelector('.mobile-nav__panel--sub');
                if (subPanel) { subPanel.setAttribute('aria-hidden', 'true'); subPanel.inert = true; }
            });
        }

        if (mobileNav) {
            mobileNav.querySelectorAll('a').forEach((link) => {
                link.addEventListener('click', closeMobileNav);
            });
        }

        document.addEventListener('click', (event) => {
            if (!mobileNav || !burger || !mobileNav.classList.contains('is-open')) return;
            if (mobileNav.contains(event.target) || burger.contains(event.target)) return;
            closeMobileNav();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeMobileNav();
            }
        });

        // Fermer le bandeau promo — via classe, jamais style.display.
        // Mémorisé en sessionStorage : masqué pour le reste de la session
        // (onglet), sans persister au-delà (contrairement à un cookie).
        const PROMO_DISMISSED_KEY = 'bc_promo_dismissed';
        if (promoBanner && sessionStorage.getItem(PROMO_DISMISSED_KEY) === '1') {
            promoBanner.classList.add('is-hidden');
            header?.classList.remove('has-promo-banner');
            document.documentElement.style.setProperty('--bc-promo-h', '0px');
        }
        if (promoClose && promoBanner) {
            promoClose.addEventListener('click', () => {
                promoBanner.classList.add('is-hidden');
                sessionStorage.setItem(PROMO_DISMISSED_KEY, '1');
                header?.classList.remove('has-promo-banner');
                document.documentElement.style.setProperty('--bc-promo-h', '0px');
            });
        }
    },
};

export default barcinoHeader;
